import React from 'react';
import { ISO8601 } from 'app/config/ISO8601';
import { createRoot } from 'react-dom/client';
import { ServiceFactory } from 'app/service/ServiceFactory';

import App from './app/App';
import './index.less';

ISO8601.overrideJsonParser();
ServiceFactory.overrideFetch();

document.addEventListener('DOMContentLoaded', () => {
    // Wait for the DOMContent to be loaded before loading the react app,
    // this way the splash screen is displayed immediately
    const root = createRoot(document.getElementById('root'));
    root.render(<App />);
});
